// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"16adcd2e","163":"4f0fcfd8","174":"2c3b7b2d","823":"00a88676","871":"933c96fe","950":"aee8e27d","957":"4c16cbe3","974":"b421035b","977":"2dd9714d"}[chunkId] + ".chunk.js";
};